export const menuRiskSelectbuttons = [
  { label: 'All', value: 'All' },
  { label: 'High', value: 'High', icon: 'fas fa-circle' },
  { label: 'Low-medium', value: 'Low', icon: 'fas fa-circle' },
];
